import React from 'react'
import { ToothNumberingSystem } from '@dataTypes/chartingPreferences.type'
import {
  formatToothNumberForDisplay,
  getPalmerToothDisplay,
} from '@utils/tooth-number-display.utils'
import './ToothNumberLabel.css'

interface ToothNumberLabelProps {
  universalToothNumber: number
  numberingSystem: ToothNumberingSystem
  className?: string
}

const ToothNumberLabel = ({
  universalToothNumber,
  numberingSystem,
  className,
}: ToothNumberLabelProps): React.ReactElement => {
  if (numberingSystem === 'palmer') {
    const palmer = getPalmerToothDisplay(universalToothNumber)
    if (palmer) {
      return (
        <span
          className={[
            'palmer-tooth-number',
            `palmer-tooth-number--${palmer.quadrant}`,
            className,
          ]
            .filter(Boolean)
            .join(' ')}
        >
          {palmer.position}
        </span>
      )
    }
  }
  return (
    <span className={className}>
      {formatToothNumberForDisplay(universalToothNumber, numberingSystem)}
    </span>
  )
}

export default ToothNumberLabel
